$(function(){
  var headerHeight = $('header').outerHeight();
  var urlHash = location.hash;
  if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({scrollTop:position}, 500);
    }, 100);
  }
  $('a[href^="#"]').click(function(){
    var href= $(this).attr("href");
    var target = $(href);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({scrollTop:position}, 500);
    return false;
  });
});




window.addEventListener('DOMContentLoaded', (event) => {
    $('.banner-slide').slick({
      autoplay: true, 
      autoplaySpeed: 3000,
      speed: 500,
      dots: true,
      arrows:true,
      centerMode: false,
      infinite: true,
      variableWidth: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<div class="slide-prev"><div class="prev-arrow"></div></div>',//矢印部分PreviewのHTMLを変更
	  nextArrow: '<div class="slide-next"><div class="next-arrow"></div></div>',//矢印部分NextのHTMLを変更
      responsive: [
			{
			breakpoint: 769,//モニターの横幅が769px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:false,
                centerMode: false,
                centerPadding: '0'
			}
		},
		{
			breakpoint: 426,//モニターの横幅が426px以下の見せ方
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                arrows:false,
                centerMode: false,
                centerPadding: '0'
			}
		}
	]
    });
  
  
  
  
});